import styled from 'styled-components';

export const LottieWrapper = styled.div`
  display: flex;
  position: absolute;
`;
